import { Injectable, inject } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Observable } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";

@Injectable({ providedIn: "root" })
export class ApplyWalletRechargeWS {
  private readonly baseHandler = inject(BaseHandler);

  execute(amount: number, token: string): Observable<string> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.APPLY_WALLET_RECHARGE_ENDPOINT())
      .setMethod(HttpMethod.post)
      .setAuthorization(new TokenAuthorization(token))
      .setBody({ amount })
      .build();

    return this.baseHandler.execute(parameters);
  }
}
